// @flow

import composeFetchSaga from './sagas/composeFetchSaga'

export default composeFetchSaga
export { default as composeFetchSaga } from './sagas/composeFetchSaga'
